export default "__VITE_ASSET__DgJ48aFb__"